import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Studio from "./pages/Studio";
import LookDetail from "./pages/LookDetail";
import Gallery from "./pages/Gallery";
import Subscription from "./pages/Subscription";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import AdminFeedback from "./pages/AdminFeedback";
import AdminCatalog from "./pages/AdminCatalog";
import AdminMetrics from "./pages/AdminMetrics";
import BlogIndex from "./pages/blog/BlogIndex";
import EthnicWearOffice2026 from "./pages/blog/EthnicWearOffice2026";
import About from "./pages/legal/About";
import Contact from "./pages/legal/Contact";
import Privacy from "./pages/legal/Privacy";
import Terms from "./pages/legal/Terms";
import Refund from "./pages/legal/Refund";
import GoogleCallback from "./pages/GoogleCallback";

const Private = ({ children, requireProfile = true }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0F0E13] flex items-center justify-center">
        <div className="text-xs uppercase tracking-[0.4em] text-[#A8A6A1]">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth?mode=login" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <GoogleCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/auth/forgot" element={<ForgotPassword />} />
      <Route path="/auth/reset" element={<ResetPassword />} />
      <Route path="/studio" element={<Private><Studio /></Private>} />
      <Route path="/gallery" element={<Private><Gallery /></Private>} />
      <Route path="/look/:id" element={<Private><LookDetail /></Private>} />
      <Route path="/subscription" element={<Private requireProfile={false}><Subscription /></Private>} />
      <Route path="/subscription/success" element={<Private requireProfile={false}><SubscriptionSuccess /></Private>} />
      <Route path="/admin/feedback" element={<AdminFeedback />} />
      <Route path="/admin/catalog" element={<AdminCatalog />} />
      <Route path="/admin/metrics" element={<AdminMetrics />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/best-ethnic-wear-for-office-2026" element={<EthnicWearOffice2026 />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/refund" element={<Refund />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{
              style: {
                background: "#1A1921",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#F7F5F2",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
